<template>
  <b-input-group>
    <template v-slot:append>
      <b-dropdown v-if="question" :variant="dropDownClass" right>
        <b-dropdown-item @click="browseSurvey">Browse answers</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item v-if="!question.active" @click="toggleQuestionActive"
          >Allow answers</b-dropdown-item
        >
        <b-dropdown-item v-if="question.active" @click="toggleQuestionActive"
          >Deny answers</b-dropdown-item
        >
        <b-dropdown-item
          v-if="!question.showInTable"
          @click="toggleQuestionListed"
          >Show in table</b-dropdown-item
        >
        <b-dropdown-item
          v-if="question.showInTable"
          @click="toggleQuestionListed"
          >Hide from table</b-dropdown-item
        >

        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item v-if="question.public == 1" disabled
          >Public</b-dropdown-item
        >
        <b-dropdown-item v-else disabled>Private</b-dropdown-item>

        <b-dropdown-item v-if="question.type == 'any'" disabled
          >Type: Anything</b-dropdown-item
        >
        <b-dropdown-item v-if="question.type == 'number'" disabled
          >Type: Number</b-dropdown-item
        >
        <b-dropdown-item v-if="question.type == 'round'" disabled
          >Type: Round</b-dropdown-item
        >
      </b-dropdown>
    </template>
    <b-input v-model="question.title" disabled :class="buttonClass" />

    <SurveyAnswerListDialog
      v-model="surveyAnswerListVisible"
      :question="question"
      :answers="answers"
    />
  </b-input-group>
</template>

<script>
import SurveyAnswerListDialog from "@/components/host/SurveyAnswerListDialog";
export default {
  name: "HostQuestionButton",
  components: {
    SurveyAnswerListDialog
  },
  props: ["question", "answers"],
  data() {
    return {
      surveyAnswerListVisible: false
    };
  },
  computed: {
    buttonClass() {
      if (this.question.active == 1) {
        return "btn-outline-primary";
      } else {
        return "btn-outline-secondary";
      }
    },
    dropDownClass() {
      if (this.question.active == 1) {
        return "primary";
      } else {
        return "secondary";
      }
    }
  },
  methods: {
    browseSurvey() {
      this.surveyAnswerListVisible = true;
    },
    toggleQuestionActive() {
      this.$topquiz.sendCommand(
        "host_setQuestionActive",
        this.$topquiz.SessionKey,
        this.question.id,
        !this.question.active
      );
    },
    toggleQuestionListed() {
      this.$topquiz.sendCommand(
        "host_setQuestionListed",
        this.$topquiz.SessionKey,
        this.question.id,
        !this.question.showInTable
      );
    }
  }
};
</script>
